import axiosWrapper, { InterceptorOptions } from './axios-wrapper'
import { isEmpty } from 'lodash'

const api = axiosWrapper.create(
  {
    baseURL: '/tracer',
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  },
  InterceptorOptions.defaultErrorInterceptor,
)

export function apiGetPlants({ make_model_id, vin }) {
  return api
    .get(`/make-models/make_model_id/${make_model_id}/vin/${vin}/plants`)
    .then((resp) => resp.data)
}

export function apiGetPlantByName({ plant_name }) {
  return api
    .get(`/plants/plant-info?plantName=${plant_name}`)
    .then((resp) => resp.data)
}

// Pass exactly one of vin_identifier or vin -- the backend resolves vin to a
// vin_identifier itself (Vin.country_and_plant_for) when vin_identifier
// isn't already known. Only ever returns the single config object for that
// one plant (there's no consumer that queries more than one plant's config
// at a time), defaulting to {} when no row exists for it.
export function fetchPlantConfig({ vin_identifier, vin }) {
  const params = new URLSearchParams()
  if (vin_identifier != null) params.set('vinIdentifier', vin_identifier)
  if (vin != null) params.set('vin', vin)
  return api.get(`/plants/config?${params.toString()}`).then((resp) => {
    if (isEmpty(resp.data.data)) return {}
    return resp.data.data[0].config ?? {}
  })
}
